export default __webpack_public_path__ + "static/media/movies-active.e94a970b.svg";